import { blue, green, orange, red, yellow, grey } from '@mui/material/colors';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de acórdão.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_ACORDAO = {
    NAO_CRIADO                : { id: 'NAO_CRIADO',                descricao: 'Não criado',                                           cor: grey[700]   },
    NAO_LIBERADO              : { id: 'NAO_LIBERADO',              descricao: 'Não liberado',                                         cor: red[900]    },
    LIBERADO                  : { id: 'LIBERADO',                  descricao: 'Liberado',                                             cor: grey[900]   },
    NAO_PUBLICAVEL            : { id: 'NAO_PUBLICAVEL',            descricao: 'Não publicável (sem publicação nesta sessão)',         cor: grey[700]   },
    NAO_ASSINADO              : { id: 'NAO_ASSINADO',              descricao: 'Não assinado',                                         cor: orange[900] },
    ASSINADO_SAG              : { id: 'ASSINADO_SAG',              descricao: 'Assinado no SAG',                                      cor: yellow[700] },
    ASSINADO_PJE              : { id: 'ASSINADO_PJE',              descricao: 'Assinado no PJe',                                      cor: yellow[700] },
    ASSINADO_ORIGEM           : { id: 'ASSINADO_ORIGEM',           descricao: 'Assinado no sistema de origem',                        cor: yellow[700] },
    ASSINADO_E_NAO_VERIFICADO : { id: 'ASSINADO_E_NAO_VERIFICADO', descricao: 'Assinado no PE, porém não verificado pela Secretaria', cor: blue[900]   },
    ASSINADO_E_VERIFICADO     : { id: 'ASSINADO_E_VERIFICADO',     descricao: 'Assinado no PE e verificado pela Secretaria',          cor: green[900]  },
    DEVOLVIDO_PARA_CORRECAO   : { id: 'DEVOLVIDO_PARA_CORRECAO',   descricao: 'Devolvido ao gabinete para correção',                  cor: red[900]    }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações de acórdão.
 * @readonly
 */
export default class SituacaoAcordao {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_ACORDAO);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_ACORDAO = 'Não foi possível identificar a situação do acórdão.';

    static getDescricao(id) {
        return SituacaoAcordao.situacaoBase.getDescricao(id);
    }

    static getCor(id) {
        return SituacaoAcordao.situacaoBase.getValorPropriedade(id, 'cor');
    }
}
